export const MOCK_DATA: any[] = [
	{
		ranking: 12,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0001',
		},
		saleAmount: 100,
		orderAmount: 10,
	},
	{
		ranking: 11,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0002',
		},
		saleAmount: 200,
		orderAmount: 20,
	},
	{
		ranking: 10,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0003',
		},
		saleAmount: 300,
		orderAmount: 30,
	},
	{
		ranking: 9,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0004',
		},
		saleAmount: 400,
		orderAmount: 40,
	},
	{
		ranking: 8,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0005',
		},
		saleAmount: 500,
		orderAmount: 50,
	},
	{
		ranking: 7,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0006',
		},
		saleAmount: 600,
		orderAmount: 60,
	},
	{
		ranking: 6,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0007',
		},
		saleAmount: 700,
		orderAmount: 70,
	},
	{
		ranking: 5,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0008',
		},
		saleAmount: 800,
		orderAmount: 80,
	},
	{
		ranking: 4,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0009',
		},
		saleAmount: 900,
		orderAmount: 90,
	},
	{
		ranking: 3,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0010',
		},
		saleAmount: 1000,
		orderAmount: 100,
	},
	{
		ranking: 2,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0011',
		},
		saleAmount: 1100,
		orderAmount: 110,
	},
	{
		ranking: 1,
		product: {
			name: 'กล่องไปรษณีย์ไซส์ A',
			description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
			featurePicturePath: '/media/kumopack-products/1.svg',
			sku: 'SKU-0012',
		},
		saleAmount: 1200,
		orderAmount: 120,
	},
]
